var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCalendarPink = function SvgCalendarPink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 3.333V10M13.333 3.333V10M5 15h30",
    stroke: "#F05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M31.667 6.667H8.333A3.332 3.332 0 005 10v21.667A3.332 3.332 0 008.333 35h23.334A3.332 3.332 0 0035 31.667V10a3.332 3.332 0 00-3.333-3.333z",
    stroke: "#F05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.688 21.215a.417.417 0 10.003.833.417.417 0 00-.003-.833M20.022 21.215a.417.417 0 10.004.833.417.417 0 00-.004-.833M28.355 21.215a.417.417 0 10.004.833.417.417 0 00-.004-.833M11.688 27.882a.417.417 0 10.004.833.417.417 0 00-.004-.833M20.022 27.882a.417.417 0 10.004.833.417.417 0 00-.004-.833",
    stroke: "#F05",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCalendarPink;